module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "l-container"
  }, [_c('p', {
    staticClass: "m-label"
  }, [_vm._v("\n    新規追加\n    "), _c('span', {
    staticClass: "errors"
  }, [(!_vm.valid) ? _c('span', [_vm._v(" " + _vm._s(_vm.errors) + " が入力されていません")]) : _vm._e(), _vm._v(" "), (_vm.valid) ? _c('span') : _vm._e()])]), _vm._v(" "), _c('btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.reset($event)
      }
    }
  }, [_vm._v("Reset")]), _vm._v(" "), _c('form', {
    staticClass: "h-adr",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.postTutor($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-wrapper"
  }, [_c('tutor-form', {
    attrs: {
      "tutor": _vm.tutor,
      "watch": _vm.watch
    }
  })], 1), _vm._v(" "), _vm._m(0)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "u-btn",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-user-plus"
  }), _vm._v("先生情報を新規追加")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a367d96"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/Tutors/TutorsAdd.vue
// module id = 1400
// module chunks = 0